import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, ActivatedRouteSnapshot, Route, Router} from '@angular/router';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {

    constructor(
        private translate: TranslateService,
        private router: Router
    ) {
    }

    switchLanguage(lang: string) {
        this.translate.use(lang).subscribe(() => {
            const navigateToLanguage = environment.defaultLanguage === this.translate.currentLang ? '' : this.translate.currentLang;
            localStorage.setItem('lang', lang);
            // this.router.navigate([]);
        });
    }

    getUserLang() {
        const availableLangs = environment.availableLanguages;
        function resolveLanguage() {
            const storedLang = localStorage.getItem('lang');
            const userLang = storedLang && storedLang.length ? storedLang : null;
            const navigatorLang = navigator.language.split('-')[0];

            if (userLang && availableLangs.includes(userLang)) {
                return userLang;
            }
            if (availableLangs.includes(navigatorLang)) {
                return navigatorLang;
            }
            return environment.defaultLanguage;
        }

        return resolveLanguage();
    }

    getCurrentLanguage() {
        return this.translate.currentLang;
    }

    get currentLanguage(): string {
        return this.translate.currentLang;
    }
}
